import { Text } from "@chakra-ui/react";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { type TextFitProps } from "./textFit.type";

export const TextFit = ({ children, max = 100, min = 10, ...textProps }: TextFitProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const [fontSize, setFontSize] = useState(max);

    const resizeText = () => {
        const el = ref.current;
        if (!el) return;

        const parent = el.parentElement;
        if (!parent) return;

        let size = max;
        el.style.fontSize = `${size}px`;
        // 줄바꿈없이
        el.style.whiteSpace = "nowrap";

        while (el.scrollWidth > parent.clientWidth && size > min) {
            size -= 1;
            el.style.fontSize = `${size}px`;
        }

        setFontSize(size);
    };

    useLayoutEffect(() => {
        resizeText();
    }, [children, min, max]);

    // ResizeObserver로 부모 사이즈 변화 감지
    useEffect(() => {
        const el = ref.current;
        let observer: ResizeObserver | null = null;
        let ticking = false;

        if (el && el.parentElement) {
            observer = new ResizeObserver(() => {
                if (!ticking) {
                    ticking = true;
                    requestAnimationFrame(() => {
                        resizeText();
                        ticking = false;
                    });
                }
            });

            observer.observe(el.parentElement);
        }

        return () => {
            if (observer) observer.disconnect();
        };
    }, []);
    return (
        <Text
            ref={ref}
            fontSize={`${fontSize}px`}
            whiteSpace="nowrap"
            overflow="hidden" // 넘칠 때 숨기지 않고 보이게
            textOverflow="ellipsis"
            {...textProps}
        >
            {children}
        </Text>
    );
};
